import { Badge, Typography } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link, useLocation } from "react-router-dom";
import classes from "./syle.module.scss";

const MenuItem = ({ title, to, icon, badgeValue = 0 }) => {
  let location = useLocation();

  return (
    <Link
      to={to}
      className={`${classes.listItem} ${
        location.pathname === `/dashboard${to ? `/${to}` : ""}` ? classes.listItemSelected : ""
      }`}
    >
      <LazyLoadImage className={classes.listItemIcon} src={icon} />
      <Badge
        badgeContent={badgeValue}
        color="primary"
        anchorOrigin={{ horizontal: "left", vertical: "top" }}
      >
        <Typography className={classes.listItemTitle}>{title}</Typography>
      </Badge>
    </Link>
  );
};

export default MenuItem;
